import React from 'react';
import NavLink from "../NavLink.react";
import {useOktaAuth} from "@okta/okta-react";

const SideNavLinks = ({permissions}) => {
  const { oktaAuth, authState } = useOktaAuth();
  const login = async () => oktaAuth.signInWithRedirect();
  const logout = async () => oktaAuth.signOut();
  const showTenantSelection = permissions.includes('tenant:view');
  return (
    <div className={'nav-items'}>
      {
        authState.isAuthenticated ?
          <NavLink onClick={() => login()} path={"/"} label={"Sign out"} /> :
          <NavLink onClick={() => logout()} path={"/"} label={"Sign in"} />
      }
      <NavLink path={"/settings"} label={"Settings"} />
      {showTenantSelection && <NavLink path={"/tenants"} label={"Tenant Selection"} /> }
      {showTenantSelection && <NavLink path={"/reports/custom"} label={"Custom Reports"} /> }
    </div>
  )
}

export default SideNavLinks;